import {
  Box,
  Button,
  Checkbox,
  Grid,
  Group,
  LoadingOverlay,
  Select,
  TextInput,
} from "@mantine/core";
import { hasLength, useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { useEffect, useRef, useState } from "react";
import {
  repositoryDelivery,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../model/MessageResponse";
import { attributes } from "@syncfusion/ej2-base";

type InventoryPosition = {
  id: number;
  invId: string | null;
  invCode: string | null;
  subInvId: string | null; // Đảm bảo đây là kiểu string
  subInvCode: string | null;
  positionCode: string | null;
  positionName: string | null;
  attribute8: string | null; //mã vị trí kho trên ERP Asia
  active: boolean | null;
  createDate: string | null;
  createBy: number | null;
  lastUpdateDate: string | null;
  lastUpdateBy: number | null;
  attribute3: number | null;
  attribute4: number | null; //1 = vị trí lưu hàng bảo hành/dịch vụ
};

type Warehouse = {
  id: number;
  name: string;
  att1: string | null;
  att2: string | null;
  att3: number;
  att4: number;
  att5: string | null;
  disabled: boolean;
  group: string | null;
  selected: boolean;
  text: string;
  value: string;
};

type EditDataViewProps = {
  id: string | number;
  onClose: any;
};

const EditWarehouseLocation = ({ id, onClose }: EditDataViewProps) => {
  const entity = {
    id: 0,
    invId: null,
    invCode: null,
    subInvId: null,
    subInvCode: null,
    positionCode: null,
    positionName: null,
    attribute8: null,
    attribute4: null, //1 = vị trí lưu hàng bảo hành/dịch vụ
    active: false,
    createDate: null,
    createBy: null,
    lastUpdateDate: null,
    lastUpdateBy: null,
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [enable, setEnable] = useState(false);
  const [listData, setListData] = useState<
    { value: string; label: string; name: string }[]
  >([]);
  const [dataSaleChannel, setDataBranchCode] = useState<any[]>([]); //lưu value và table của select chi nhánh

  const [dataBranch, setDataBranch] = useState<any[]>([]); //lưu dữ liệu chi nhánh lấy được
  // giữ danh sách chi nhánh trong ref để hàm validate luôn đọc được dữ liệu mới nhất
  const branchListRef = useRef<any[]>([]);
  const [dataInventory, setDataInventory] = useState<any[]>([]); //lưu dữ liệu kho lấy được

  // const fetchDataWarehouse = async () => {
  //   try {
  //     const response = await repositoryPos.get(
  //       `api/v1/TblDmInventory/get-list?Skip=0&Take=1000`
  //     );
  //     if (response && response.success) {
  //       const data = response.data;
  //       const formattedData = data.map((item: Warehouse) => ({
  //         value: String(item.id),
  //         label: item.name,
  //       }));
  //       setListData(formattedData);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };
  // useEffect(() => {
  //   fetchDataWarehouse();
  // }, []);

  const form = useForm<InventoryPosition>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
      attribute3: null,
    },
    validate: {
      invId: (value: string | null) => {
        if (!value) {
          return "Vui lòng chọn chi nhánh!";
        }
      },
      subInvId: (value: string | null) => {
        if (!value) {
          return "Vui lòng chọn kho con!";
        }
      },
      positionCode: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập mã vị trí!";
        }
        return hasLength(
          { max: 15 },
          "Mã vị trí phải nhỏ hơn 15 kí tự!"
        )(value as string);
      },
      positionName: (value?: string | null) => {
        if (value) {
          return hasLength(
            { max: 250 },
            "Tên vị trí phải nhỏ hơn 250 kí tự!"
          )(value as string);
        }
        return "Vui lòng nhập tên vị trí!";
      },
      attribute8: (value: string | null | undefined, values: any) => {
        // vị trí thuộc chi nhánh của công ty DVT bắt buộc phải có mã bên ERP Asia
        const isDvt =
          branchListRef.current.find(
            (b: any) => String(b.value) === String(values?.invId)
          )?.attr6 === "DVT";
        if (isDvt && (!value || value.trim().length === 0))
          return "Vị trí thuộc chi nhánh công ty DVT phải nhập mã vị trí Asia!";
        if (value && value.length > 500)
          return "Mã vị trí Asia phải nhỏ hơn 500 kí tự!";
      },
    },
  });

  // useEffect(() => {

  // }, [listData]);

  const handleEditTblDMBranch = async (dataSubmit: InventoryPosition) => {
    const dataBranchInv = dataBranch.find(
      ///Tìm dữ liệu chi nhánh lấy được để lấy mã chi nhánh
      (item: any) => item.value == Number(dataSubmit.invId)
    );
    const dataSubInvCode = dataInventory.find(
      //tìm dữ liệu kho lấy được để lấy mã kho
      (item: any) => item.inventoryId == Number(dataSubmit.subInvId)
    );
    dataSubmit.attribute3 = dataSubmit.attribute3 ? 1 : 0;
    const resultDataSubmit = {
      ...dataSubmit,
      // giữ nguyên mã cũ nếu không dò được trong danh mục, tránh ghi null vào db
      invCode: dataBranchInv?.att2 ?? dataSubmit.invCode,
      subInvCode: dataSubInvCode?.inventoryCode ?? dataSubmit.subInvCode,
    };

    console.log("resultDataSubmit", resultDataSubmit);
    open();
    const dataApi = await repositoryDelivery.post<
      MessageResponse<InventoryPosition>
    >(`/api/v1/TblDmItemPosition/update`, resultDataSubmit);
    if (dataApi?.success) {
      onClose((prev: any) => !prev);
      modals.closeAll();
    }
    close();
  };

  /**
   * Chi nhánh thuộc pháp nhân DVT được phép sửa toàn bộ thông tin vị trí kho.
   * dataBranch giữ nguyên response của get-select-branch nên có sẵn attr6 = CompanyCode.
   */
  const isDvtBranch =
    dataBranch.find(
      (b: any) => String(b.value) === String(form.getValues().invId),
    )?.attr6 === "DVT";

  const callApiGetData = async () => {
    open();
    const callapi = await repositoryDelivery.get<
      MessageResponse<InventoryPosition>
    >(`/api/v1/TblDmItemPosition/update?id=${id}`);

    if (!callapi?.success) {
      NotificationExtension.Fails("Bạn không có quyền sửa!!!");
      modals.closeAll();
      return;
    }

    if (callapi) {
      const dataApi = callapi?.data;
      if (dataApi != null) {
        form.setValues(dataApi);
        form.resetDirty(dataApi);
      }
      close();
    } else {
      NotificationExtension.Fails("Dữ liệu không tồn tại");
      modals.closeAll();
    }
  };

  //Call api chi nhánh
  const DataBranchCode = async () => {
    try {
      // không truyền auth để lấy đủ danh mục, tránh dò không ra chi nhánh của bản ghi
      const response = await repositoryPos.get<MessageResponse<[]>>(
        `api/v1/TblDmInventory/get-select-branch`
      );
      if (response && response.success) {
        setDataBranch(response.data);
        branchListRef.current = response.data ?? [];
        const result = response.data
          .filter((i: any) => i.value !== null && i.text !== null)
          .map((item: any) => ({
            value: String(item.value),
            label: item.text,
          }));
        setDataBranchCode(result);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };
  //Call api KHO theo chi nhánh
  const fetchDataInventory = async (id: number) => {
    try {
      const response = await repositoryPos.get<MessageResponse<[]>>(
        `/api/v1/TblDmInventory/get-select-by-branch?branchId=${id}`
      );
      if (response && response.success) {
        setDataInventory(response.data);
        const result = response.data
          .filter(
            (i: any) => i.inventoryId !== null && i.inventoryCode !== null
          )
          .map((item: any) => ({
            value: String(item.inventoryId),
            label: item.inventoryCode,
            name: item.inventoryName,
          }));
        setListData(result);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  useEffect(() => {
    const data = listData.find(
      (item) => item.value === form.getValues().subInvId?.toString()
    );
    if (data) form.setFieldValue("InvName", data?.name);
  }, [form.getValues().subInvId?.toString(), listData]);

  useEffect(() => {
    if (id) {
      Promise.all([callApiGetData(), DataBranchCode()]);
    }
  }, [id]);

  useEffect(() => {
    if (form.getValues().invId) {
      fetchDataInventory(Number(form.getValues().invId));
    }
  }, [form.getValues().invId]);

  useEffect(() => {
    if (form.isDirty()) {
      setEnable(true);
    } else {
      setEnable(false);
    }
  }, [form]);

  return (
    <>
      <Box
        component="form"
        mx="auto"
        onSubmit={form.onSubmit((e: InventoryPosition) => {
          handleEditTblDMBranch(e);
        })}
        style={{ position: "relative", width: "100%", height: "auto" }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Grid mt={10}>
          {/* <Grid.Col span={12}>
            <TextInput
              label={"Kho tổng"}
              placeholder={"Mã kho tổng"}
              type="text"
              withAsterisk
              {...form.getInputProps("invCode")}
            />
          </Grid.Col> */}

          <Grid.Col span={{ base: 12, md: 6 }}>
            <Select
              label="Chi nhánh"
              withAsterisk
              data={dataSaleChannel}
              readOnly
              variant="filled"
              onClick={() => {
                if (dataSaleChannel.length === 0) {
                  DataBranchCode();
                }
              }}
              placeholder="Chọn chi nhánh"
              value={form.getValues().invId?.toString()}
              key={form.key("invId")}
              {...form.getInputProps("invId")}
              onChange={(e) => {
                form.setFieldValue("invId", e);
                form.setFieldValue("subInvId", null);
                fetchDataInventory(e ? Number(e) : 0);
              }}
            />
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 6 }}>
            <Select
              key={form.key("subInvId")}
              label="Mã Kho"
              readOnly
              variant="filled"
              placeholder="Chọn mã kho"
              withAsterisk
              value={form.getValues().subInvId?.toString()}
              disabled={form.getValues().invId === null}
              data={listData}
              {...form.getInputProps("subInvId")}
              onChange={(e) => {
                form.setFieldValue("subInvId", e);
                const selectedWarehouse = listData.find(
                  (item) => item.value === e
                );
                if (selectedWarehouse) {
                  form.setFieldValue("InvName", selectedWarehouse.name);
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <TextInput
              key={form.key("InvName")}
              label="Tên kho"
              placeholder="Tên kho"
              withAsterisk
              readOnly
              variant="filled"
              {...form.getInputProps("InvName")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <TextInput
              label={"Mã vị trí"}
              placeholder={"Nhập mã vị trí"}
              type="text"
              readOnly
              variant="filled"
              withAsterisk
              key={form.key("positionCode")}
              {...form.getInputProps("positionCode")}
            />
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 6 }}>
            <TextInput
              label={"Tên vị trí"}
              placeholder={"Nhập tên vị trí"}
              type="text"
              readOnly
              variant="filled"
              withAsterisk
              key={form.key("positionName")}
              {...form.getInputProps("positionName")}
            />
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 6 }}>
            <TextInput
              label={"Mã vị trí Asia"}
              placeholder={"Nhập mã vị trí bên ERP Asia"}
              type="text"
              withAsterisk={isDvtBranch}
              key={form.key("attribute8")}
              {...form.getInputProps("attribute8")}
            />
          </Grid.Col>

          <Grid.Col span={12}>
            <Checkbox
              key={form.key("attribute4")}
              label="Lên bảng kê hàng lỗi"
              description="Đánh dấu để hàng nhập vào vị trí này được lên bảng kê hàng lỗi"
              defaultChecked={form.getValues().attribute4 === 1}
              onChange={(e) =>
                form.setFieldValue("attribute4", e.currentTarget.checked ? 1 : null)
              }
            />
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 6 }}>
            <Checkbox
              key={form.key("active")}
              label="Hoạt động"
              readOnly={!isDvtBranch}
              defaultValue={form.getValues().active ?? false}
              defaultChecked={form.getValues().active ?? false}
              {...form.getInputProps("active")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <Checkbox
              key={form.key("attribute3")}
              label="Đồng bộ CC/DC"
              readOnly={!isDvtBranch}
              defaultValue={form.getValues().attribute3}
              defaultChecked={form.getValues().attribute3 === 1}
              {...form.getInputProps("attribute3")}
            />
          </Grid.Col>
        </Grid>

        <Group
          justify="end"
          mt="xs"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="button"
            color="gray"
            loading={visible}
            onClick={() => {
              modals.closeAll();
            }}
          >
            Đóng
          </Button>
          <Button type="submit" loading={visible}>
            Lưu
          </Button>
        </Group>
      </Box>
    </>
  );
};

export default EditWarehouseLocation;
